module.exports = __webpack_public_path__ + "static/media/SiteMap.5c6a7c60.jpg";